// 订单与合同：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 采购订单
export const buy = Object.freeze({
  "buyOrders.title": "我的購買訂單",
  "buyOrders.orderNumber": "訂單編號",
  "buyOrders.productTitle": "標題",
  "buyOrders.partNumber": "料號",
  "buyOrders.image": "圖片",
  "buyOrders.quantity": "數量",
  "buyOrders.totalAmount": "總金額",
  "buyOrders.status": "訂單狀態",
  "buyOrders.time": "時間",
  "buyOrders.actions": "操作",
  "buyOrders.review": "去評價",
  "buyOrders.viewReview": "查看評價",
  "buyOrders.viewDetails": "查看詳情",
  "buyOrders.payCommission": "支付佣金",
  "buyOrders.uploadPaymentProof": "上傳付款憑證",
  "buyOrders.confirmReceipt": "確認收貨",
});

// 联系人
export const contact = Object.freeze({
  "contactDialog.noTags": "暫無可選標籤",
  "contactDialog.contact": "聯絡人",
  "contactDialog.enterContactName": "請填寫聯絡人姓名",
  "contactDialog.ms": "女士",
  "contactDialog.mr": "先生",
  "contactDialog.phone": "聯繫電話",
  "contactDialog.enterPhone": "請填寫聯繫電話",
  "contactDialog.wechatNumber": "微信號碼",
  "contactDialog.enterWechatNumber": "請填寫微信號碼",
  "contactDialog.hometown": "聯絡人籍貫",
  "contactDialog.enterHometown": "請填寫聯絡人籍貫",
  "contactDialog.character": "聯絡人性格",
  "contactDialog.hobbies": "聯絡人愛好",
  "contactDialog.bindNegotiator": "綁定談判人",
  "contactDialog.searchNegotiatorNameOrPhone":
    "搜索需要綁定的談判人姓名/流動電話號碼",
  "contactDialog.setDefault": "設為預設聯絡人",
  "contactDialog.cancel": "取消",
  "contactDialog.gender": "性別",
  "contactDialog.characterShort": "性格",
  "contactDialog.hobbiesShort": "愛好",
  "contactDialog.searchNegotiator": "搜索需要綁定的談判人",
  "contactDialog.chooseNegotiator": "選擇談判人",
  "contactDialog.noMore": "沒有更多了",
  "contactDialog.choosePerson": "選擇人員",
  "contactDialog.newContact": "新建聯絡人",
  "contactDialog.changeContact": "更換聯絡人",
  "contactDialog.choosePersonHint": "搜索並選擇需要添加的人員",
  "contactDialog.newContactHint": "補充聯絡人資料，用於訂單溝通與後續協作",
  "contactDialog.changeContactHint":
    "選擇需要使用的聯絡人，並可同步設置預設聯絡人",
  "contactDialog.confirmAdd": "確認添加",
  "contactDialog.confirmChange": "確認更換",
  "contactDialog.searchPersonName": "搜索人員姓名",
  "contactDialog.searchContactNameOrPhone": "搜索聯絡人姓名或電話",
  "contactDialog.noMatchingContacts": "未找到匹配的聯絡人",
  "contactDialog.noContactsToChange": "暫無聯絡人可更換",
  "contactDialog.noMatchingPeople": "未找到匹配的人員",
  "contactDialog.searchPersonToAdd": "輸入姓名搜索需要添加的人員",
  "contactDialog.supplierIdRequired": "供應商ID不能為空",
  "contactDialog.unnamedPerson": "未命名人員",
});

// 购物与谈判人
export const broker = Object.freeze({
  "mobileCart.title": "購物車",
  "mobileCart.totalPrefix": "共",
  "mobileCart.totalSuffix": "件商品",
  "mobileCart.edit": "編輯",
  "mobileCart.selectAll": "全選",
  "mobileCart.total": "合計：",
  "mobileCart.checkout": "結算({count})",
  "mobileCart.delete": "刪除",
  "mobileCart.empty": "您的購物車是空的, 快去逛逛吧",
  "mobileCart.browse": "去逛逛",
  "mobileBroker.notBroker": "你不是談判人，申請成為談判人，然後一個申請表單",
  "mobileBroker.underReview": "審核中",
  "mobileBroker.apply": "申請成為談判人",
  "mobileBroker.reviewing": "正在審核中",
  "mobileBroker.applicationInfo": "申請資料",
  "mobileBroker.shopName": "店鋪名",
  "mobileBroker.shopNamePlaceholder": "請輸入店鋪名稱",
  "mobileBroker.ownerName": "貨主姓名",
  "mobileBroker.ownerNamePlaceholder": "請輸入真實姓名",
  "mobileBroker.ownerNameInvalid": "請輸入正確的姓名",
  "mobileBroker.ownerPhone": "貨主流動電話號碼",
  "mobileBroker.ownerPhonePlaceholder": "請輸入11位流動電話號碼",
  "mobileBroker.ownerPhoneInvalid": "請輸入正確的流動電話號碼",
  "mobileBroker.ownerWechat": "貨主微信號",
  "mobileBroker.ownerWechatPlaceholder": "請輸入常用微信號",
  "mobileBroker.ownerWechatRequired": "請輸入微信號",
  "mobileBroker.reason": "店鋪申請理由",
  "mobileBroker.reasonPlaceholder": "請簡要説明申請原因",
  "mobileBroker.reasonRequired": "請填寫申請理由",
  "mobileBroker.submitting": "提交中...",
  "mobileBroker.submit": "提交申請",
  "mobileBroker.succeeded": "申請成功!",
  "mobileBroker.failed": "提交失敗",
  "mobileBroker.retryLater": "提交失敗，請稍後重試",
});

// 移动结算
export const checkout = Object.freeze({
  "mobileCheckout.title": "訂單結算台",
  "mobileCheckout.chooseAddress": "請選擇配送地址",
  "mobileCheckout.goodsTotal": "共 {count} 件商品，合計：",
  "mobileCheckout.orderAmount": "訂單總金額：",
  "mobileCheckout.coupon": "優惠券：",
  "mobileCheckout.noCoupon": "無優惠券可用",
  "mobileCheckout.deliveryFee": "配送費用：",
  "mobileCheckout.chooseAddressFirst": "請先選擇配送地址",
  "mobileCheckout.paymentMethod": "支付方式",
  "mobileCheckout.balancePayment": "餘額支付（可用 ¥ {balance} 元）",
  "mobileCheckout.buyerNotePlaceholder": "選填：買家留言（50字內）",
  "mobileCheckout.amountDue": "實付款：",
  "mobileCheckout.submitOrder": "提交訂單",
  "mobileCheckout.paymentSuccess": "支付成功",
});

// 移动订单组件
export const mobileComponents = Object.freeze({
  "mobileOrder.splitOrder": "拆單",
  "mobileOrder.split": "已拆分",
  "mobileOrder.fastOrder": "快單",
  "mobileOrder.mergedOrder": "合併訂單",
  "mobileOrder.contractAndOrderNumbers": "合同、訂單編號",
  "mobileOrder.contractNumber": "合同編號",
  "contractNumber.partiesRequired": "請先選擇不同的買賣雙方公司",
  "contractNumber.companyChanged": "公司選擇已變更，請重新確認編號",
  "contractNumber.reviewFiles": "合同編號發生變化，請核對已下載或上傳的合同文件後再提交",
  "contractNumber.unavailable": "合同編號暫時無法產生，請稍後重試；持續失敗請聯絡管理員",
  "contractNumber.companyCodeRequired": "對方公司尚未設定編碼，請先完善公司資料",
  "contractNumber.invalidCompanyCode": "對方公司編碼格式不正確，請先完善公司資料",
  "contractNumber.expired": "合同編號已失效，請重新取得並核對合同文件",
  "contractNumber.alreadySubmitted": "該表單已提交，請重新整理以查看原合同",
  "contractNumber.businessRequired": "僅商務可分配合同編號",
  "contractNumber.purchasePending": "選擇賣方公司後自動產生",
  "contractNumber.salePending": "選擇買方公司後自動產生",
  "mobileOrder.orderNumber": "訂單編號",
  "mobileOrder.goodsNumber": "商品編號",
  "mobileOrder.close": "關閉",
  "mobileOrder.copy": "複製",
  "mobileOrder.brand": "品牌",
  "mobileOrder.title": "標題",
  "mobileOrder.quantity": "數量",
  "mobileOrder.unitPrice": "單價",
  "mobileOrder.quantityBeforeSplit": "拆分前數量",
  "mobileOrder.contacts": "聯絡人",
  "mobileOrder.details": "詳情",
  "mobileOrder.collapseTradeInfo": "收起交易資料",
  "mobileOrder.moreTradeInfo": "更多交易資料",
  "mobileOrder.viewDetails": "查看詳情",
  "mobileOrder.moreActions": "更多操作",
  "mobileOrder.more": "更多",
  "mobileOrder.inviteSeller": "邀請貨主",
  "mobileOrder.generateSalesOrder": "生成銷售訂單",
  "mobileOrder.generatePurchaseOrder": "生成採購訂單",
  "mobileOrder.cancel": "取消",
  "mobileOrder.inspectGoods": "驗貨",
  "mobileOrder.inspectionDetails": "驗貨詳情",
  "mobileOrder.rateNow": "去評價",
  "mobileOrder.viewRating": "查看評價",
  "mobileOrder.uploadInvoice": "上傳發票",
  "mobileOrder.confirmPaymentReceived": "確認收款",
  "mobileOrder.uploadShippingInfo": "上傳物流資料",
  "mobileOrder.uploadPaymentProof": "上傳付款憑證",
  "mobileOrder.confirmDelivery": "確認收貨",
  "mobileOrder.company": "公司",
  "mobileOrder.callNumber": "撥打{phone}",
  "mobileOrder.phone": "電話",
  "mobileOrder.splitAction": "拆分",
  "mobileOrder.revokeAction": "撤回",
  "mobileOrder.buy": "採購",
  "mobileOrder.sell": "銷售",
  "mobileOrder.copySuccess": "複製成功",
  "mobileOrder.copyFailed": "複製失敗",
  "mobileOrder.notice": "提示",
  "mobileOrder.revokeSplitConfirm": "確認撤回已拆分的訂單？",
  "mobileOrder.confirmRevoke": "確認撤回",
  "mobileOrder.revokeSuccess": "撤回成功",
  "mobileOrder.paymentProofRequired": "請上傳付款憑證！",
  "mobileOrder.paymentProofUploaded": "上傳付款憑證成功！",
  "mobileOrder.shippingAddressRequired": "請選擇收貨地址！",
  "mobileOrder.proofOrRemarkRequired": "請上傳憑證或備註！",
  "mobileOrder.shippingInfoUploaded": "上傳物流資料成功！",
  "mobileOrder.deliveryConfirmed": "確認收貨成功！",
  "mobileOrder.paymentConfirmed": "確認收款成功！",
  "mobileOrder.invoiceRequired": "請至少上傳一份發票！",
  "mobileOrder.invoiceUploaded": "上傳發票成功！",
  "mobileOrder.filter": "篩選",
  "mobileOrder.searchAll": "全部搜索",
  "mobileOrder.searchName": "名稱搜索",
  "mobileOrder.searchPartNumber": "料號搜索",
  "mobileOrder.partNumberOrNameSearch": "料號、名稱搜索",
  "mobileOrder.nameSearch": "名稱搜索",
  "mobileOrder.partNumberSearch": "料號搜索",
  "mobileOrder.invite": "邀請",
});

// 移动订单
export const mobile = Object.freeze({
  "mobileOrders.myOrders": "我的訂單",
  "mobileOrders.all": "全部",
  "mobileOrders.awaitingPayment": "待支付",
  "mobileOrders.awaitingShipment": "待發貨",
  "mobileOrders.awaitingReceipt": "待收貨",
  "mobileOrders.awaitingReview": "待評價",
  "mobileOrders.submitted": "提交成功",
  "mobileOrders.paymentSucceeded": "支付成功",
});

// 移动购物车
export const mobileCart = Object.freeze({
  "mobileShopCart.goodsList": "商品清單",
  "mobileShopCart.unnamedProduct": "未命名商品",
  "mobileShopCart.partNumber": "料號",
  "mobileShopCart.unitPrice": "單價",
  "mobileShopCart.quantity": "數量",
  "mobileShopCart.pieceUnit": "件",
  "mobileShopCart.sellerInfo": "賣家資料",
  "mobileShopCart.companyName": "公司名稱",
  "mobileShopCart.contactPerson": "聯絡人",
  "mobileShopCart.contactPhone": "聯繫電話",
  "mobileShopCart.noPendingProducts": "暫無待提交商品",
  "mobileShopCart.estimatedTotal": "預估合計",
  "mobileShopCart.itemCount": "共 {count} 項",
  "mobileShopCart.finalAmountHint": "最終金額以訂單確認為準",
  "mobileShopCart.approximately": "約",
  "mobileShopCart.buyerInfo": "買家資料",
  "mobileShopCart.enterCompanyName": "請填寫公司名稱",
  "mobileShopCart.taxNumber": "公司税號",
  "mobileShopCart.enterTaxNumber": "請填寫公司税號",
  "mobileShopCart.enterContactPerson": "請填寫聯絡人",
  "mobileShopCart.contactInfo": "聯絡方式",
  "mobileShopCart.enterPhone": "請填寫流動電話號碼",
  "mobileShopCart.deliveryAddress": "交貨地址",
  "mobileShopCart.enterDeliveryAddress": "請填寫交貨地址",
  "mobileShopCart.attachments": "附件資料",
  "mobileShopCart.uploadOrderInfo": "上傳訂單資料",
  "mobileShopCart.maxTenFiles": "最多上傳 10 個檔案",
  "mobileShopCart.orderInfo": "訂單資料",
  "mobileShopCart.infoUsageHint": "資料僅用於本次採購意向溝通",
  "mobileShopCart.submitting": "正在提交",
  "mobileShopCart.checkoutTitle": "提交採購意向單",
  "mobileShopCart.submitPurchaseIntent": "提交採購意向",
  "mobileShopCart.loginFirst": "請先登入",
  "mobileShopCart.submitSuccess": "採購意向單提交成功！",
  "mobileShopCart.cartTitle": "購物車",
  "mobileShopCart.done": "完成",
  "mobileShopCart.manage": "管理",
  "mobileShopCart.searchPlaceholder": "搜索商品料號、名稱",
  "mobileShopCart.loading": "正在載入",
  "mobileShopCart.product": "商品",
  "mobileShopCart.selectProduct": "選擇{product}",
  "mobileShopCart.noImage": "暫無圖片",
  "mobileShopCart.outOfStock": "庫存不足",
  "mobileShopCart.lowStock": "庫存緊張",
  "mobileShopCart.decreaseProductQuantity": "減少{product}數量",
  "mobileShopCart.editQuantity": "手動輸入數量，當前{count}",
  "mobileShopCart.increaseProductQuantity": "增加{product}數量",
  "mobileShopCart.favorite": "收藏",
  "mobileShopCart.delete": "刪除",
  "mobileShopCart.emptyCart": "採購清單為空",
  "mobileShopCart.noSearchResults": "沒有找到匹配的商品，換個關鍵詞試試",
  "mobileShopCart.emptyCartHint": "挑選合適的商品後，可在這裏統一結算",
  "mobileShopCart.clearSearch": "清除搜索",
  "mobileShopCart.shopNow": "去採購",
  "mobileShopCart.changeQuantity": "修改購買數量",
  "mobileShopCart.currentStock": "當前庫存",
  "mobileShopCart.pieces": "{count} 件",
  "mobileShopCart.purchaseQuantity": "購買數量",
  "mobileShopCart.decreaseInputQuantity": "減少輸入數量",
  "mobileShopCart.increaseInputQuantity": "增加輸入數量",
  "mobileShopCart.quantityLimit": "購買數量不可超過當前庫存 {count} 件",
  "mobileShopCart.currentOutOfStock": "當前商品庫存不足",
  "mobileShopCart.cancel": "取消",
  "mobileShopCart.confirm": "確定",
  "mobileShopCart.selectedDetails": "已選商品明細",
  "mobileShopCart.selectedSummary": "{kinds} 種商品，共 {count} 件",
  "mobileShopCart.totalQuantity": "合計數量：{count} 件",
  "mobileShopCart.selectAll": "全選",
  "mobileShopCart.viewDetails": "查看明細",
  "mobileShopCart.moveToFavorites": "移入收藏",
  "mobileShopCart.syncing": "同步中...",
  "mobileShopCart.selectProductFirst": "請先選擇商品",
  "mobileShopCart.favoriteComingSoon": "收藏功能即將開放",
  "mobileShopCart.selectToDelete": "請先選擇要刪除的商品",
  "mobileShopCart.confirmDeleteSelected": "確定刪除已選的 {count} 種商品嗎？",
  "mobileShopCart.confirmRemoveProduct": "確定將該商品移出採購清單嗎？",
  "mobileShopCart.deleteProduct": "刪除商品",
  "mobileShopCart.deleteSuccess": "刪除成功",
  "mobileShopCart.stockLimitReached": "已達到庫存上限",
  "mobileShopCart.invalidQuantity": "請輸入正確的購買數量",
  "mobileShopCart.maximumQuantity": "當前最多可購買 {count} 件",
  "mobileShopCart.loadFailed": "採購清單載入失敗，請稍後重試",
  "mobileShopCart.multipleCurrencies": "多幣種商品",
  "mobileShopCart.multipleCurrenciesHint":
    "所選商品包含多個幣種，提交後將拆分為多個訂單，是否繼續？",
  "mobileShopCart.continueOrder": "繼續下單",
  "mobileShopCart.syncFailed": "採購清單同步失敗",
});

// 移动交易订单
export const mobileTransactions = Object.freeze({
  "transactionOrders.title": "交易訂單中心",
  "transactionOrders.all": "全部",
  "transactionOrders.buy": "採購",
  "transactionOrders.sell": "銷售",
  "transactionOrders.follow": "意向",
  "transactionOrders.pendingNotice": "您現在有{count}個{unit}",
  "transactionOrders.pending": "待處理",
  "transactionOrders.loginRequired": "請先登入！",
  "transactionOrders.negotiatorRequired": "你不是談判人，請申請成為談判人",
  "transactionOrders.underReview": "審核中",
  "transactionOrders.applyNegotiator": "申請成為談判人",
  "transactionOrders.loading": "載入中...",
  "transactionOrders.noMore": "我們是有底線的",
  "transactionOrders.backToTop": "回到頂部",
  "transactionOrders.noOrders": "暫無訂單數據",
  "transactionOrders.noFollowOrders": "暫無意向訂單數據",
  "transactionOrders.followUnit": "跟單",
  "transactionOrders.orderUnit": "訂單",
  "transactionOrders.underReviewMessage": "正在審核中",
});

// 订单详情
export const details = Object.freeze({
  "preOrderDetail.title": "商品訂單詳情",
  "preOrderDetail.goodsCode": "商品編號",
  "preOrderDetail.edit": "編輯",
  "preOrderDetail.imageLoading": "圖片載入中",
  "preOrderDetail.unitPrice": "單價",
  "preOrderDetail.stock": "庫存",
  "preOrderDetail.viewGoods": "查看商品詳情",
  "preOrderDetail.viewDetails": "查看詳情",
  "preOrderDetail.subOrders": "商品子訂單",
  "preOrderDetail.orderNumber": "訂單編號",
  "preOrderDetail.quantity": "數量",
  "preOrderDetail.noSubOrders": "暫無子訂單",
  "preOrderDetail.sellerContacts": "賣方聯絡人",
  "preOrderDetail.buyerContacts": "買方聯絡人",
  "preOrderDetail.negotiator": "談判人",
  "preOrderDetail.business": "商務",
  "preOrderDetail.noContacts": "暫無聯絡人資料",
  "preOrderDetail.changeRecords": "商品資料修改記錄",
  "preOrderDetail.changedAt": "修改時間",
  "preOrderDetail.goodsPrice": "商品單價",
  "preOrderDetail.goodsQuantity": "商品數量",
  "preOrderDetail.validUntil": "有效期",
  "preOrderDetail.none": "無",
  "preOrderDetail.noRecords": "暫無修改記錄",
  "preOrderDetail.invite": "邀請同事協作",
  "preOrderDetail.contactMethod": "聯絡方式",
  "preOrderDetail.fillContact": "請填寫聯絡方式",
  "preOrderDetail.copyLink": "點擊複製鏈接",
  "preOrderDetail.noData": "暫無數據",
  "preOrderDetail.changeGoods": "修改商品資料",
  "preOrderDetail.price": "價格",
  "preOrderDetail.fillPrice": "請填寫價格",
  "preOrderDetail.fillQuantity": "請填寫數量",
  "preOrderDetail.selectDate": "請選擇有效期",
  "preOrderDetail.submitChange": "提交修改",
  "preOrderDetail.chooseDate": "選擇有效期",
  "preOrderDetail.usd": "美元",
  "preOrderDetail.cny": "人民幣",
  "preOrderDetail.yuan": "元",
  "preOrderDetail.copySuccess": "複製成功",
  "preOrderDetail.linkCopied": "鏈接複製成功",
  "preOrderDetail.missingCode": "未獲取到商品編號",
  "preOrderDetail.requireChange": "請至少填寫價格、數量或有效期其中一項",
  "preOrderDetail.changeSuccess": "修改成功",
  "preOrderDetail.changeFailedShort": "修改失敗",
  "preOrderDetail.changeFailed": "修改失敗，請重試",
  "preOrderDetail.retryLater": "修改失敗，請稍後重試",
  "transactionDetail.title": "訂單詳情",
  "transactionDetail.orderGoods": "訂單商品",
  "transactionDetail.singleOrder": "單筆訂單",
  "transactionDetail.mergedOrder": "合併訂單",
  "transactionDetail.orderUnit": "筆",
  "transactionDetail.orderUnitOne": "筆",
  "transactionDetail.orderLabel": "訂單",
  "transactionDetail.copyContractNumber": "複製合同編號",
  "transactionDetail.fastOrder": "快單",
  "transactionDetail.logisticsDetails": "物流詳情",
  "transactionDetail.serviceUnavailable": "未開通",
  "transactionDetail.copyTrackingNumber": "複製物流單號",
  "transactionDetail.receiverInfo": "收貨資料",
  "transactionDetail.progress": "進度",
  "transactionDetail.businessProcess": "商務流程",
  "transactionDetail.businessProcessLoading": "商務流程載入中",
  "transactionDetail.noBusinessProcess": "暫無商務流程數據",
  "transactionDetail.purchaseProcess": "採購商務流程",
  "transactionDetail.salesProcess": "銷售商務流程",
  "transactionDetail.parallelNode": "並行節點：{name}",
  "transactionDetail.parallel": "並行",
  "transactionDetail.current": "當前",
  "transactionDetail.remarks": "備註",
  "transactionDetail.nodeApprovals": "節點審批 {count} 人",
  "transactionDetail.nodeApprovalDetails": "節點審批明細",
  "transactionDetail.parallelApprovalDetails": "並行節點審批明細",
  "transactionDetail.collapseProcess": "收起完整流程",
  "transactionDetail.expandProcess": "查看完整流程",
  "transactionDetail.contract": "合同",
  "transactionDetail.contractInfo": "合同資料",
  "transactionDetail.orderDetails": "訂單明細",
  "transactionDetail.parties": "雙方",
  "transactionDetail.attachments": "附件",
  "transactionDetail.logistics": "物流",
  "transactionDetail.afterSalesPolicy": "售後條款",
  "transactionDetail.noAfterSalesPolicy": "暫無售後條款",
  "transactionDetail.productIndex": "商品{index}",
  "transactionDetail.sellerInfo": "賣方資料",
  "transactionDetail.buyerInfo": "買方資料",
  "transactionDetail.contacts": "聯繫",
  "transactionDetail.attachmentIntro":
    "發票、訂單票據、付款、合同及發貨資料統一歸檔",
  "transactionDetail.fileCount": "{count} 個檔案",
  "transactionDetail.attachmentCenter": "附件中心",
  "transactionDetail.attachmentCenterDescription":
    "集中查看發票、訂單票據、付款、合同及發貨資料",
  "transactionDetail.totalFileCount": "共 {count} 個檔案",
  "transactionDetail.expand": "展開",
  "transactionDetail.collapse": "收起",
  "transactionDetail.expandContract": "展開合同",
  "transactionDetail.collapseContract": "收起合同",
  "transactionDetail.invoice": "正式發票",
  "transactionDetail.noPiFiles": "暫無 PI 檔案",
  "transactionDetail.noInvoiceFiles": "暫無正式發票",
  "transactionDetail.noVatFiles": "暫無增值税發票",
  "transactionDetail.noContractFiles": "暫無交易合同",
  "transactionDetail.noOrderReceiptFiles": "暫無訂單憑證",
  "transactionDetail.noPaymentProofFiles": "暫無付款憑證",
  "transactionDetail.noShippingProofFiles": "暫無發貨憑證",
  "transactionDetail.noFiles": "暫無檔案",
  "transactionDetail.attachment": "附件",
  "transactionDetail.preview": "預覽",
  "transactionDetail.rejected": "已駁回",
  "transactionDetail.reject": "駁回",
  "transactionDetail.unknownFile": "未知檔案",
  "transactionDetail.pdfFile": "PDF 檔案",
  "transactionDetail.imageFile": "圖片檔案",
  "transactionDetail.videoFile": "影片檔案",
  "transactionDetail.attachmentFile": "附件檔案",
  "transactionDetail.rejectInvoice": "駁回發票",
  "transactionDetail.rejectPaymentProof": "駁回付款憑證",
  "transactionDetail.noAttachment": "暫無{label}",
  "transactionDetail.shippingCompany": "發貨公司",
  "transactionDetail.trackingNumber": "物流單號",
  "transactionDetail.logisticsProgress": "物流進度",
  "transactionDetail.receiptAddress": "收貨地址",
  "transactionDetail.contactPerson": "聯絡人",
  "transactionDetail.contactPhone": "聯繫電話",
  "transactionDetail.expandLogistics": "查看物流詳情",
  "transactionDetail.collapseLogistics": "收起物流詳情",
  "transactionDetail.viewRemarks": "查看備註",
  "transactionDetail.closeRemarks": "關閉備註彈窗",
  "transactionDetail.close": "關閉",
  "transactionDetail.reviewRejectReason": "填寫複核駁回原因",
  "transactionDetail.rejectReason": "填寫駁回理由",
  "transactionDetail.closeReject": "關閉駁回彈窗",
  "transactionDetail.confirmSubmit": "確認提交",
  "transactionDetail.tradeOrders": "交易訂單中心",
  "transactionDetail.viewDetails": "查看詳情",
  "transactionDetail.contractNumber": "合同編號",
  "transactionDetail.deliveryDate": "交貨日期",
  "transactionDetail.orderType": "訂單類型",
  "transactionDetail.trade": "貿易",
  "transactionDetail.supplyChain": "供應鏈",
  "transactionDetail.factoring": "保理放賬",
  "transactionDetail.totalPrice": "綜合總價",
  "transactionDetail.commission": "綜合佣金",
  "transactionDetail.quantity": "數量",
  "transactionDetail.orderIndex": "訂單{index}",
  "transactionDetail.orderInfo": "訂單資料",
  "transactionDetail.orderNumber": "訂單編號",
  "transactionDetail.productName": "產品名稱",
  "transactionDetail.productBrand": "產品品牌",
  "transactionDetail.partNumber": "產品料號",
  "transactionDetail.deliveryRegion": "交貨地區",
  "transactionDetail.unitPrice": "產品單價",
  "transactionDetail.productQuantity": "產品數量",
  "transactionDetail.productTotal": "產品總價",
  "transactionDetail.sellerCompany": "賣家資料",
  "transactionDetail.buyerCompany": "買家資料",
  "transactionDetail.companyName": "公司名稱",
  "transactionDetail.companyEnglishName": "公司名稱(英)",
  "transactionDetail.taxNumber": "公司税號",
  "transactionDetail.registrationNumber": "商業登記號",
  "transactionDetail.primaryContact": "主聯絡人",
  "transactionDetail.companyAddress": "公司地址",
  "transactionDetail.bank": "開戶銀行",
  "transactionDetail.bankEnglishName": "銀行英名",
  "transactionDetail.bankAccount": "銀行賬號",
  "transactionDetail.receivingAccount": "收款賬號",
  "transactionDetail.recipient": "收貨人",
  "transactionDetail.recipientPhone": "收貨電話",
  "transactionDetail.placeOrderInfo": "下單資料",
  "transactionDetail.originalPrice": "商品原價",
  "transactionDetail.offerPrice": "意向價格",
  "transactionDetail.approx": "約",
  "transactionDetail.originCertificate": "原產地證明",
  "transactionDetail.inviteSellerLink": "邀請貨主鏈接",
  "transactionDetail.agentService": "訂單客服",
  "transactionDetail.purchaseBusiness": "採購商務",
  "transactionDetail.salesBusiness": "銷售商務",
  "transactionDetail.purchaseContacts": "採購聯絡人",
  "transactionDetail.salesContacts": "銷售聯絡人",
  "transactionDetail.platformContacts": "平台聯絡人",
  "transactionDetail.proformaInvoice": "形式發票",
  "transactionDetail.orderReceipt": "訂單憑證",
  "transactionDetail.vatInvoice": "增值税發票",
  "transactionDetail.paymentProof": "付款憑證",
  "transactionDetail.shippingProof": "發貨憑證",
  "transactionDetail.tradeContract": "交易合同",
  "transactionDetail.pickedUp": "已攬收",
  "transactionDetail.pickedUpDesc": "快件已被攬收點接收",
  "transactionDetail.inTransit": "運輸中",
  "transactionDetail.inTransitDesc": "快件正在運輸途中",
  "transactionDetail.outForDelivery": "派送中",
  "transactionDetail.outForDeliveryDesc": "快件正在派送中，請保持電話暢通",
  "transactionDetail.delivered": "已簽收",
  "transactionDetail.deliveredDesc": "快件已被本人簽收",
  "transactionDetail.reviewConfirm": "複核確認",
  "transactionDetail.reviewQuestion": "確認該{target}複核通過嗎？",
  "transactionDetail.approve": "確認通過",
  "transactionDetail.cancel": "取消",
  "transactionDetail.rejectSuccess": "駁回成功",
  "transactionDetail.rejectFailed": "駁回失敗，請重試",
  "transactionDetail.noContractId": "合同ID為空，無法提交複核",
  "transactionDetail.reviewFailed": "複核失敗，請重試",
  "transactionDetail.reviewApproved": "複核通過",
  "transactionDetail.reviewRejected": "複核駁回成功",
  "transactionDetail.copySuccess": "複製成功",
  "transactionDetail.copyFailed": "複製失敗",
  "transactionDetail.previewFailed": "附件預覽失敗",
  "transactionDetail.authFailed": "授權失敗",
  "transactionDetail.loadFailed": "訂單詳情載入失敗",
  "transactionDetail.afterSaleApplication": "填寫售後申請",
  "transactionDetail.transactionNumber": "交易編號",
  "transactionDetail.afterSaleType": "售後類型",
  "transactionDetail.selectType": "請選擇類型",
  "transactionDetail.afterSaleReason": "售後原因",
  "transactionDetail.selectReason": "請選擇原因",
  "transactionDetail.description": "詳細描述",
  "transactionDetail.fillDescription": "請填寫詳細描述",
  "transactionDetail.imageProof": "圖片憑證",
  "transactionDetail.imageHelp":
    "支持 jpg/jpeg/png 格式，最多 9 張，建議上傳產品實拍圖、包裝圖等",
  "transactionDetail.videoProof": "影片憑證",
  "transactionDetail.uploadVideo": "上傳影片憑證",
  "transactionDetail.videoHelp":
    "支持 mp4/avi 格式，最多 3 個，建議上傳功能演示/故障影片",
  "transactionDetail.submitApplication": "提交申請",
  "transactionDetail.reset": "重置",
  "transactionDetail.refundOnly": "僅退款",
  "transactionDetail.returnAndRefund": "退貨退款",
  "transactionDetail.exchange": "換貨",
  "transactionDetail.factoryRepair": "返廠維修",
  "transactionDetail.partMismatch": "晶片料號與描述不符",
  "transactionDetail.qualityIssue": "產品存在品質問題",
  "transactionDetail.shortQuantity": "數量不足",
  "transactionDetail.differentPart": "需要更換其他料號",
  "transactionDetail.suspectedFake": "疑似假貨",
  "transactionDetail.other": "其他",
  "transactionDetail.missingAuthCode": "授權參數缺失，請重新授權",
  "transactionDetail.loginSuccess": "登入成功",
  "transactionDetail.requestError": "請求異常！",
  "transactionDetail.missingOrderId": "訂單ID為空",
  "transactionDetail.selectTransaction": "請選擇交易編號",
  "transactionDetail.selectAfterSaleType": "請選擇售後類型",
  "transactionDetail.selectAfterSaleReason": "請選擇售後原因",
  "transactionDetail.uploadImageProof": "請上傳圖片憑證",
  "transactionDetail.submitFailed": "提交失敗，請重試",
  "transactionDetail.sellerRole": "貨主",
  "transactionDetail.businessRole": "商務",
  "transactionDetail.negotiatorRole": "談判人",
  "transactionDetail.buyerRole": "買家",
});

// 桌面购物车
export const desktopCart = Object.freeze({
  "pcCart.cartTitle": "採購清單",
  "pcCart.productCount": "共 {count} 件商品",
  "pcCart.searchPlaceholder": "搜索商品料號、名稱",
  "pcCart.selectAll": "全選",
  "pcCart.deleteSelected": "刪除已選",
  "pcCart.moveToFavorites": "移入收藏",
  "pcCart.selectedProducts": "已選擇 {count} 件商品",
  "pcCart.partNumber": "料號",
  "pcCart.stock": "庫存",
  "pcCart.pieces": "{count} 件",
  "pcCart.approx": "約",
  "pcCart.subtotal": "小計",
  "pcCart.deleteProduct": "刪除商品",
  "pcCart.emptyTitle": "採購清單為空",
  "pcCart.emptyDescription": "您的採購清單還沒有任何商品",
  "pcCart.shopNow": "去採購",
  "pcCart.orderSummary": "訂單摘要",
  "pcCart.selectedItems": "已選商品",
  "pcCart.totalItems": "商品總數",
  "pcCart.usdItemsTotal": "美元商品合計",
  "pcCart.cnyItemsTotal": "人民幣商品合計",
  "pcCart.total": "合計",
  "pcCart.overallTotal": "綜合總價",
  "pcCart.submitIntent": "提交採購意向",
  "pcCart.pendingConfirmation": "共 {count} 件商品待確認",
  "pcCart.priceFluctuation": "商品價格隨市場波動",
  "pcCart.paymentMethods": "支持多種支付方式",
  "pcCart.selectedPreview": "已選商品預覽",
  "pcCart.selectFavoriteFirst": "請先選擇要收藏的商品",
  "pcCart.favoriteSuccess": "收藏成功",
  "pcCart.selectDeleteFirst": "請先選擇要刪除的商品",
  "pcCart.confirmDeleteSelected": "確定要刪除選中的商品嗎？",
  "pcCart.confirmDeleteProduct": "確定要刪除該商品嗎？",
  "pcCart.notice": "提示",
  "pcCart.confirm": "確定",
  "pcCart.cancel": "取消",
  "pcCart.deleteSuccess": "刪除成功",
  "pcCart.selectProductFirst": "請先選擇商品",
  "pcCart.multiCurrencyWarning":
    "已選中多個幣種的商品，如果下單會拆分成多個訂單，請確定是否繼續下單",
  "pcCart.backToCart": "返回採購清單",
  "pcCart.orderProducts": "下單商品",
  "pcCart.productImage": "商品圖片",
  "pcCart.unnamedProduct": "未命名商品",
  "pcCart.model": "型號：",
  "pcCart.quantity": "數量：",
  "pcCart.unitPiece": "件",
  "pcCart.noSelectedProducts": "暫無已選商品",
  "pcCart.productsTotal": "商品合計",
  "pcCart.exchangeDisclaimer": "以當前匯率折算，僅供參考",
  "pcCart.buyerInfo": "買家資料",
  "pcCart.buyerInfoHint": "用於生成採購意向單",
  "pcCart.companyName": "公司名稱",
  "pcCart.companyPlaceholder": "請填寫公司名稱",
  "pcCart.taxNumber": "税號",
  "pcCart.taxPlaceholder": "請填寫税號",
  "pcCart.contact": "聯絡人",
  "pcCart.contactPlaceholder": "請填寫聯絡人",
  "pcCart.contactDetails": "聯絡方式",
  "pcCart.contactDetailsPlaceholder": "請填寫聯絡方式",
  "pcCart.deliveryAddress": "交貨地址",
  "pcCart.deliveryAddressPlaceholder": "請填寫交貨地址",
  "pcCart.uploadOrderInfo": "上傳訂單資料",
  "pcCart.uploadHint": "支持上傳合同、採購單或其他訂單資料，最多 10 個檔案",
  "pcCart.uploadFile": "上傳檔案",
  "pcCart.productDetails": "{name}資料",
  "pcCart.productNumber": "商品 {count}",
  "pcCart.contactPhone": "聯繫電話",
  "pcCart.submitting": "正在提交",
  "pcCart.submitPurchaseIntent": "提交採購意向單",
  "pcCart.loginFirst": "請先登入",
  "pcCart.submitSuccess": "採購意向單提交成功！",
});

// 合同审核
export const contractReview = Object.freeze({
  "contractReview.back": "返回",
  "contractReview.salesOrderInfo": "銷售訂單資料",
  "contractReview.salesOrderDescription": "核對商品、訂單與銷售合同明細",
  "contractReview.purchaseOrderInfo": "採購訂單資料",
  "contractReview.purchaseOrderDescription": "核對商品、合同與採購明細",
  "contractReview.productInfo": "商品資料",
  "contractReview.contractInfo": "合同資料",
  "contractReview.inviteSeller": "邀請貨主綁定商品",
  "contractReview.productProvider": "商品提供人",
  "contractReview.noTerms": "無",
  "contractReview.productIndex": "商品{index}",
  "contractReview.contractNumberPlaceholder": "請輸入合同編號",
  "contractReview.copySuccess": "複製成功",
  "contractReview.copyFailed": "複製失敗",
  "contractReview.sellerInfo": "賣方資料",
  "contractReview.buyerInfo": "買方資料",
  "contractReview.sellerPaymentInfo": "賣方收款資料",
  "contractReview.moreSellerInfo": "更多賣方資料",
  "contractReview.moreBuyerInfo": "更多買方資料",
  "contractReview.moreBuyerPaymentInfo": "更多買家資料",
  "contractReview.newContact": "新建聯絡人",
  "contractReview.changeContact": "更換聯絡人",
  "contractReview.addBank": "新增銀行",
  "contractReview.changeBank": "更換銀行",
  "contractReview.clear": "清空",
  "contractReview.fillRemarks": "請填寫備註",
  "contractReview.attachment": "附件",
  "contractReview.uploadAttachment": "上傳附件",
  "contractReview.requiredField": "{party}{field}不能為空",
  "contractReview.seller": "賣方",
  "contractReview.buyer": "買方",
  "contractReview.contactAdded": "聯絡人添加成功",
  "contractReview.contactChanged": "聯絡人更換成功",
  "contractReview.productName": "產品名稱",
  "contractReview.partNumber": "產品料號",
  "contractReview.productQuantity": "產品數量",
  "contractReview.unitPrice": "產品單價",
  "contractReview.productTotal": "產品總價",
  "contractReview.brand": "品牌",
  "contractReview.productNumber": "商品編號",
  "contractReview.orderNumber": "訂單編號",
  "contractReview.deliveryRegion": "交貨地區",
  "contractReview.dateCode": "批次（DC）",
  "contractReview.goodsCondition": "貨物情況",
  "contractReview.deliveryDate": "交貨日期",
  "contractReview.orderType": "訂單類型",
  "contractReview.afterSalesTerms": "售後條款",
  "contractReview.orderRemarks": "訂單備註",
  "contractReview.contractNumber": "合同編號",
  "contractReview.grandTotal": "綜合總價",
  "contractReview.paymentMethod": "付款方式",
  "contractReview.companyName": "公司名稱",
  "contractReview.companyNameZh": "公司名稱(中)",
  "contractReview.companyNameEn": "公司名稱(英)",
  "contractReview.accountName": "賬戶名稱",
  "contractReview.contact": "聯絡人",
  "contractReview.primaryContact": "主聯絡人",
  "contractReview.contactPhone": "聯繫電話",
  "contractReview.phone": "電話",
  "contractReview.remarks": "備註",
  "contractReview.companyAddress": "公司地址",
  "contractReview.taxNumber": "公司税號",
  "contractReview.registrationNumber": "商業登記號",
  "contractReview.bankNameEn": "銀行英名",
  "contractReview.bankNameZh": "銀行中名",
  "contractReview.bank": "開戶銀行",
  "contractReview.bankAccount": "銀行賬號",
  "contractReview.bankAddressZh": "銀行地址（中）",
  "contractReview.bankAddressEn": "銀行地址（英）",
  "contractReview.bankBranch": "開戶支行",
  "contractReview.bankBranchCode": "聯行號",
  "contractReview.receivingAccount": "收款賬號",
  "contractReview.shippingAddress": "收貨地址",
  "contractReview.recipient": "收貨人",
  "contractReview.recipientPhone": "收貨電話",
  "contractReview.salesTotal": "銷售總價",
  "contractReview.purchaseTotal": "採購總價",
  "contractReview.profit": "利潤統計",
  "contractReview.orderImages": "訂單資料圖片",
  "contractReview.noAttachments": "暫無附件",
  "contractReview.tradeContract": "交易合同",
  "contractReview.customerUploadsSingle": "由客戶上傳單章合同檔案",
  "contractReview.uploadTradeContract": "上傳交易合同",
  "contractReview.viewTradeContract": "查看交易合同",
  "contractReview.confirmUpload": "確定上傳",
  "contractReview.uploadTemplate": "上傳合同模板",
  "contractReview.contractTemplate": "合同模板",
  "contractReview.uploadSingle": "上傳單章合同",
  "contractReview.singleContract": "單章合同",
  "contractReview.uploadDual": "上傳雙章合同",
  "contractReview.dualContract": "雙章合同",
  "contractReview.approvalAttachmentsHint": "上傳審批所需發票及其他附件",
  "contractReview.otherAttachments": "其他附件",
  "contractReview.contractRemarks": "合同備註",
  "contractReview.fillContractRemarks": "請填寫合同備註",
  "contractReview.noRemarks": "暫無備註",
  "contractReview.buyerAttachments": "買方附件",
  "contractReview.myAttachments": "我的附件",
  "contractReview.purchaseSellerInfo": "採購賣方資料",
  "contractReview.purchaseBuyerInfo": "採購買方資料",
  "contractReview.reject": "駁回",
  "contractReview.relatedOrderHint":
    "選擇需要關聯到當前銷售訂單的歷史訂單、合同或付款審核記錄",
  "contractReview.rejectReason": "填寫駁回理由",
  "contractReview.confirmSubmit": "確認提交",
  "contractReview.addCc": "添加抄送人",
  "contractReview.addCcHint": "搜索並選擇需要同步本次銷售訂單進度的人員",
  "contractReview.searchCc": "搜索抄送人",
  "contractReview.cc": "抄送人",
  "contractReview.contractPreview": "合同預覽",
  "contractReview.initiateApproval": "發起合同審批",
  "contractReview.reviewSalesContract": "審核銷售合同",
  "contractReview.viewSalesContract": "查看銷售合同",
  "contractReview.reviewSalesOrder": "審核銷售訂單",
  "contractReview.viewSalesOrder": "查看銷售訂單",
  "contractReview.confirmTradeContract": "確認交易合同",
  "contractReview.approveReview": "審核通過",
  "contractReview.confirmTemplate": "確認合同模板",
  "contractReview.confirmSalesOrder": "確認銷售訂單",
  "contractReview.trade": "貿易",
  "contractReview.supplyChain": "供應鏈",
  "contractReview.factoring": "保理放賬",
  "contractReview.payBeforeDelivery": "先款後貨",
  "contractReview.payAfterDelivery": "先貨後款",
  "contractReview.notStarted": "待發起",
  "contractReview.underReview": "審核中",
  "contractReview.approved": "已通過",
  "contractReview.rejected": "已駁回",
  "contractReview.unknown": "未知",
  "contractReview.reviewRemarks": "審核備註",
  "contractReview.fillReviewerRemarks": "請填寫審核人備註",
});

// 跟单
export const follow = Object.freeze({
  "pcFollow.searchPlaceholder": "搜索商品名稱、料號、品牌、類型、數量",
  "pcFollow.loginRequired": "請先登入！",
  "pcFollow.notNegotiator": "你不是談判人，請申請成為談判人",
  "pcFollow.underReview": "審核中",
  "pcFollow.applyNegotiator": "申請成為談判人",
  "pcFollow.businessTracking": "商務跟單頁",
  "pcFollow.negotiatorTracking": "談判人跟單頁",
  "pcFollow.buyer": "買家",
  "pcFollow.seller": "貨主",
  "pcFollow.reviewInProgress": "正在審核中",
  "pcFollow.titleWithRole": "{role}{title}",
});

// 桌面订单组件
export const desktopComponents = Object.freeze({
  "pcOrder.merged": "合併",
  "pcOrder.contractNumber": "合同編號：",
  "pcOrder.orderNumber": "訂單編號：",
  "pcOrder.productNumber": "商品編號：",
  "pcOrder.split": "拆分",
  "pcOrder.revoke": "撤回",
  "pcOrder.inviteSellerLink": "邀請貨主鏈接",
  "pcOrder.splitOrder": "拆單",
  "pcOrder.fastOrder": "快單",
  "pcOrder.personLabelSeparator": "：",
  "pcOrder.buyerRole": "買家",
  "pcOrder.sellerRole": "貨主",
  "pcOrder.salesNegotiatorRole": "銷售談判人",
  "pcOrder.salesBusinessRole": "銷售商務",
  "pcOrder.purchaseNegotiatorRole": "採購談判人",
  "pcOrder.purchaseBusinessRole": "採購商務",
  "pcOrder.supervisorRole": "監督人",
  "pcOrder.inspectorRole": "驗貨人",
  "pcOrder.uploadTradeContract": "上傳交易合同",
  "pcOrder.uploadSingleStampContract": "上傳單章合同",
  "pcOrder.uploadDualStampContract": "上傳雙章合同",
  "pcOrder.editTradeContract": "修改交易合同",
  "pcOrder.initiateContractReview": "發起合同審批",
  "pcOrder.initiateTemplateReview": "發起合同模板審批",
  "pcOrder.viewTradeContract": "查看交易合同",
  "pcOrder.viewPaymentProof": "查看付款憑證",
  "pcOrder.viewContractTemplate": "查看合同模板",
  "pcOrder.confirmTradeContract": "確認交易合同",
  "pcOrder.confirmContractTemplate": "確認合同模板",
  "pcOrder.productPublished": "產品發佈",
  "pcOrder.platformListed": "平台展示",
  "pcOrder.brand": "品牌",
  "pcOrder.name": "名稱",
  "pcOrder.quantity": "數量",
  "pcOrder.originalQuantity": "拆分前數量",
  "pcOrder.unitPrice": "單價",
  "pcOrder.viewDetails": "查看詳情",
  "pcOrder.withdrawOrder": "撤回訂單",
  "pcOrder.generateSalesOrder": "生成銷售訂單",
  "pcOrder.generatePurchaseOrder": "生成採購訂單",
  "pcOrder.inspect": "驗貨",
  "pcOrder.inspectionDetails": "驗貨詳情",
  "pcOrder.reviewNow": "去評價",
  "pcOrder.viewReview": "查看評價",
  "pcOrder.uploadInvoice": "上傳發票",
  "pcOrder.confirmPayment": "確認收款",
  "pcOrder.uploadShipping": "上傳物流資料",
  "pcOrder.uploadPaymentProof": "上傳付款憑證",
  "pcOrder.confirmReceipt": "確認收貨",
  "pcOrder.purchaseProduct": "採購商品",
  "pcOrder.salesProduct": "銷售商品",
  "pcOrder.onlyBuyerMayWithdraw": "僅訂單買家本人可以撤回訂單",
  "pcOrder.orderIdUnavailable": "未獲取到訂單ID",
  "pcOrder.withdrawWarning": "撤回後需要重新下單，確認撤回該訂單嗎？",
  "pcOrder.notice": "提示",
  "pcOrder.confirmWithdraw": "確認撤回",
  "pcOrder.cancel": "取消",
  "pcOrder.withdrawSuccess": "撤回成功",
  "pcOrder.revokeSplitWarning": "確認撤回已拆分的訂單？",
  "pcOrder.copySuccess": "複製成功",
  "pcOrder.copyFailed": "複製失敗",
  "pcOrder.paymentProofRequired": "請上傳付款憑證！",
  "pcOrder.paymentProofUploaded": "上傳付款憑證成功！",
  "pcOrder.proofOrNoteRequired": "請上傳憑證或備註！",
  "pcOrder.shippingUploaded": "上傳物流資料成功！",
  "pcOrder.receiptConfirmed": "確認收貨成功！",
  "pcOrder.paymentConfirmed": "確認收款成功！",
  "pcOrder.invoiceRequired": "請至少上傳一份發票！",
  "pcOrder.invoiceUploaded": "上傳發票成功！",
  "pcOrder.splitDialogTitle": "拆分訂單",
  "pcOrder.splitDialogHint": "選擇拆分單數，並分配每單數量",
  "pcOrder.totalProducts": "商品總數",
  "pcOrder.productUnitPrice": "商品單價",
  "pcOrder.splitInto": "拆分為",
  "pcOrder.splitEvenlyHint": "系統將自動平均分配，可按需微調",
  "pcOrder.orderUnit": "單",
  "pcOrder.quantityPerOrder": "每單數量",
  "pcOrder.fullyAllocated": "已分配完",
  "pcOrder.remaining": "剩餘 {count}",
  "pcOrder.orderNumbered": "訂單 {count}",
  "pcOrder.confirmSplit": "確認拆分",
  "pcOrder.invalidSplitQuantity":
    "拆單數量不能少於2，且每單分配數量之和必須等於商品總數！",
  "pcOrder.splitSuccess": "拆分成功",
  "pcOrder.splitFailed": "拆分失敗",
});

// 桌面交易订单
export const desktopTransactions = Object.freeze({
  "pcTransaction.title": "交易訂單中心",
  "pcTransaction.pendingAction": "待處理",
  "pcTransaction.allOrders": "全部訂單",
  "pcTransaction.purchaseOrders": "採購訂單",
  "pcTransaction.salesOrders": "銷售訂單",
  "pcTransaction.intentions": "意向列表",
  "pcTransaction.searchAll": "全部搜索",
  "pcTransaction.searchName": "名稱搜索",
  "pcTransaction.searchPartNumber": "料號搜索",
  "pcTransaction.searchPlaceholder": "{field}搜索",
  "pcTransaction.name": "名稱",
  "pcTransaction.partNumberShort": "料號",
  "pcTransaction.nameAndPartNumber": "名稱、料號",
  "pcTransaction.inviteCollaboration": "邀請協作",
  "pcTransaction.orderingCompany": "下單公司",
  "pcTransaction.supplier": "供應商",
  "pcTransaction.productName": "貨物名稱",
  "pcTransaction.partNumber": "規格型號（料號）",
  "pcTransaction.startDate": "訂單開始日期",
  "pcTransaction.to": "至",
  "pcTransaction.endDate": "訂單結束日期",
  "pcTransaction.search": "搜索",
  "pcTransaction.exportReport": "導出報表",
  "pcTransaction.loading": "載入中...",
  "pcTransaction.noMore": "沒有更多了",
  "pcTransaction.backToTop": "回到頂部",
  "pcTransaction.pendingFollows": "您現在有{count}個跟單",
  "pcTransaction.pendingOrders": "您現在有{count}個訂單",
  "pcTransaction.noIntentionOrders": "暫無意向訂單數據",
  "pcTransaction.noOrders": "暫無訂單數據",
  "pcTransaction.exportFailed": "報表導出失敗",
  "pcTransaction.salesPaymentReport": "銷售付款報表",
  "pcTransaction.purchasePaymentReport": "採購付款報表",
  "pcTransaction.summaryReport": "交易彙總報表",
  "pcTransaction.allDates": "全部",
  "pcTransaction.exportSuccess": "報表導出成功",
});

// 个人订单
export const personal = Object.freeze({
  "personalOrderList.buyerTitle": "我是買家",
  "personalOrderList.saleTitle": "我的銷售訂單",
  "personalOrderList.followTitle": "我的跟單訂單",
  "personalOrderList.noMore": "我們是有底線的",
  "personalOrderList.noData": "暫無數據",
  "personalOrderList.imageLoading": "圖片載入中",
  "personalOrderList.supplyInfo": "貨源資料",
  "personalOrderList.unitPrice": "單價",
  "personalOrderList.quantity": "數量",
  "personalOrderList.viewDetails": "查看詳情",
  "personalOrderList.completeInfo": "資料完善",
  "personalOrderList.image": "圖片",
  "personalOrderList.title": "標題",
  "personalOrderList.brand": "品牌",
  "personalOrderList.time": "時間",
  "personalOrderList.action": "操作",
  "personalOrderList.all": "全部",
  "personalOrderList.pendingConfirmation": "待確認",
  "personalOrderList.pendingCommission": "待付佣金",
  "personalOrderList.transactionComplete": "交易完成",
  "personalOrderList.pendingReview": "待評價",
  "personalOrderList.reviewed": "已評價",
  "personalOrderList.supply": "貨源",
  "personalOrderList.buyRequest": "求購",
  "contractList.title": "我的合同記錄",
  "contractList.auditStatus": "審核狀態",
  "contractList.selectStatus": "請選擇狀態",
  "contractList.contractNumber": "合同編號",
  "contractList.pending": "待審核",
  "contractList.approved": "已通過",
  "contractList.rejected": "已駁回",
  "contractList.all": "全部",
  "contractList.remark": "備註",
  "contractList.createdAt": "創建時間",
  "contractList.action": "操作",
  "contractList.viewDetails": "查看詳情",
  "orderDetail.title": "訂單詳情",
  "orderDetail.status": "訂單狀態",
  "orderDetail.commissionInfo": "佣金資料",
  "orderDetail.commissionAmount": "佣金金額",
  "orderDetail.paymentStatus": "支付狀態",
  "orderDetail.unpaid": "待支付",
  "orderDetail.paid": "已支付",
  "orderDetail.paymentTime": "支付時間",
  "orderDetail.orderInfo": "訂單資料",
  "orderDetail.orderNumber": "訂單號",
  "orderDetail.orderTime": "下單時間",
  "orderDetail.goodsAmount": "商品總金額",
  "orderDetail.orderAmount": "訂單金額",
  "orderDetail.buyer": "買家",
  "orderDetail.buyerCompany": "買家中間公司",
  "orderDetail.seller": "貨主",
  "orderDetail.sellerCompany": "貨主中間公司",
  "orderDetail.payCommission": "去支付佣金",
  "orderDetail.uploadPaymentProof": "上傳支付憑證",
  "orderDetail.confirmReceipt": "確認收貨",
  "orderDetail.commissionPayment": "佣金支付",
  "orderDetail.payNow": "立即支付￥{amount}",
  "orderDetail.paymentProof": "支付憑證",
  "orderDetail.paymentEvidence": "支付憑據",
  "orderDetail.submit": "提交",
  "orderDetail.confirmPayment": "確認收款",
  "orderDetail.shippingCompany": "發貨公司",
  "orderDetail.trackingNumber": "物流單號",
  "orderDetail.shippingProof": "發貨憑證",
  "orderDetail.uploadShippingProof": "上傳發貨憑證",
  "orderDetail.shippingInfo": "上傳發貨資料",
  "orderDetail.ship": "發貨",
  "orderDetail.goShip": "去發貨",
  "orderDetail.invoiceInfo": "上傳發票資料",
  "orderDetail.invoiceProof": "發票憑證",
  "orderDetail.uploadInvoiceProof": "上傳發票憑證",
  "orderDetail.required": "必填項",
  "orderDetail.validNumber": "請輸入有效的數字",
  "orderDetail.paymentSuccess": "支付成功！",
  "orderDetail.uploadSuccess": "上傳成功！",
  "orderDetail.receiptSuccess": "完成收貨！",
  "orderDetail.confirmSuccess": "確認成功！",
  "orderDetail.shipSuccess": "發貨成功！",
  "orderDetail.wechatQrAlt": "微信支付二維碼",
  "orderDetail.loading": "載入中...",
});

// 拆单
export const split = Object.freeze({
  "splitOrder.title": "拆分訂單",
  "splitOrder.close": "關閉拆分訂單彈窗",
  "splitOrder.yuan": "元",
  "splitOrder.totalQuantity": "總數：",
  "splitOrder.splitInto": "訂單拆分成",
  "splitOrder.orderCount": "拆分後的訂單數量",
  "splitOrder.ordersUnit": "單",
  "splitOrder.orderLabel": "訂單{label}：",
  "splitOrder.splitQuantity": "拆分數量",
  "splitOrder.remaining": "剩餘可分：{count}",
  "splitOrder.confirm": "確認拆分",
  "splitOrder.unallocatedQuantity": "還有剩餘數量未拆分完！",
  "splitOrder.success": "拆分成功",
  "splitOrder.failed": "拆分失敗",
});

// 出库单列表：状态、仓库及接口错误仅作显示翻译，不改业务值。
export const outboundList = Object.freeze({
  "outboundList.title": "出庫單列表",
  "outboundList.status": "出庫單狀態",
  "outboundList.allStatuses": "全部狀態",
  "outboundList.allWarehouses": "全部倉庫",
  "outboundList.startDate": "開始日期",
  "outboundList.endDate": "結束日期",
  "outboundList.rangeSeparator": "至",
  "outboundList.dispatchStartDate": "出庫開始日期",
  "outboundList.dispatchEndDate": "出庫結束日期",
  "outboundList.add": "新增出庫單",
  "outboundList.total": "共 {count} 筆",
  "outboundList.empty": "暫無出庫單資料",
  "outboundList.pending": "待審批",
  "outboundList.inReview": "審批中",
  "outboundList.approved": "審批通過",
  "outboundList.rejected": "審批駁回",
  "outboundList.warehouseHengda": "香港恆達",
  "outboundList.warehouseHualian": "香港華聯",
  "outboundList.warehouseShenzhen": "深圳",
  "outboundList.review": "審核出庫單",
  "outboundList.view": "查看出庫單",
  "outboundList.details": "查看詳情",
  "outboundList.rejectionReason": "駁回原因",
  "outboundList.invalidId": "出庫單ID無效，請重新整理列表",
  "outboundList.loadFailed": "出庫單列表載入失敗，請重試",
  "outboundList.dateOrderError": "出庫開始日期不能晚於結束日期",
  "outboundList.queryRequired": "查詢參數不可留空",
  "outboundList.invalidStatus": "審批狀態必須為0至3",
  "outboundList.invalidPage": "頁碼必須大於0",
  "outboundList.invalidPageSize": "每頁筆數必須介乎1至100",
  "outboundList.forbidden": "無權操作出庫單",
  "outboundList.unavailable": "出庫操作失敗，請稍後重試",
});

// 采购／销售订单生成与关联内容：三语仅作用于显示，不改选项、审批状态及原始正文。
export const contractFlow = Object.freeze({
  "contractFlow.bankAttachments": "銀行附件",
  "contractFlow.purchaseTitle": "採購商務建立採購訂單",
  "contractFlow.salesTitle": "銷售商務建立銷售訂單",
  "contractFlow.purchaseIntro": "填寫採購訂單資料，確認交易主體與審核流程",
  "contractFlow.salesIntro": "填寫銷售訂單資料，確認交易主體與審核流程",
  "contractFlow.purchaseOnBehalf": "代採代付",
  "contractFlow.purchaseWithAdvance": "代採墊付",
  "contractFlow.factoryPackaging": "原廠原包",
  "contractFlow.nonFactoryPackaging": "非原廠原包",
  "contractFlow.selfPackagedChips": "自行封裝顆粒",
  "contractFlow.testedOriginalMarking": "原標（測試）",
  "contractFlow.nonOriginalMarking": "非原標",
  "contractFlow.refurbished": "翻新",
  "contractFlow.used": "二手",
  "contractFlow.salesContract": "銷售合同",
  "contractFlow.purchaseContract": "採購合同",
  "contractFlow.paymentReview": "付款審核",
  "contractFlow.order": "訂單",
  "contractFlow.payment": "付款",
  "contractFlow.relatedSearchPlaceholder":
    "搜尋關聯訂單的訂單編號、標題、內容等",
  "contractFlow.relatedNotFound": "找不到關聯內容",
  "contractFlow.relatedUnavailable": "暫無可關聯內容",
  "contractFlow.selectedCount": "已選 {count} 項",
  "contractFlow.noDetails": "暫無詳細資料",
  "contractFlow.missingDetails": "暫無{type}詳細資料",
  "contractFlow.relatedLoadFailed": "關聯內容載入失敗",
  "contractFlow.expandRelated": "展開關聯內容",
  "contractFlow.collapseRelated": "收起關聯內容",
  "contractFlow.deleteRelated": "刪除關聯內容",
  "contractFlow.selectRelatedOrder": "選擇關聯訂單",
  "contractFlow.deselectRelatedOrder": "取消選擇關聯訂單",
  "contractFlow.purchaseRelatedHint":
    "選擇需關聯至目前採購訂單的歷史訂單、合同或付款審核記錄",
  "contractFlow.salesRelatedHint":
    "選擇需關聯至目前銷售訂單的歷史訂單、合同或付款審核記錄",
  "contractFlow.paymentRelatedHint":
    "選擇需關聯至目前付款審批的歷史訂單、合同或付款審核記錄",
  "contractFlow.purchaseCcHint": "搜尋並選擇需要接收本次採購訂單進度的人員",
  "contractFlow.salesCcHint": "搜尋並選擇需要接收本次銷售訂單進度的人員",
});

// 手机端业务流程：三语只改变固定界面文案。
export const mobileWorkflow = Object.freeze({
  "orderForm.productPrice": "商品{number}價格",
  "orderForm.enterRegistrationNumber": "請填寫商業登記號",
  "orderForm.removeProduct": "刪除商品{number}",
  "orderForm.taxNumber": "稅號：{number}",
  "orderForm.personInCharge": "負責人：{name}",
  "orderForm.cannotDeselect": "目前訂單不能取消選取",
  "inspection.deselect": "取消選取",
  "contractReview.noFixedFlow": "暫未取得固定審核流程",
  "preOrder.buy": "購買",
  "preOrder.sell": "出售",
  "contractReview.purchaseReviewTitle": "審核採購合同",
  "contractReview.approvalInformation": "審批資訊",
  "contractReview.downloadFailed": "下載失敗",
  "contractReview.ccAlreadyAdded": "此副本收件人已加入",
  "invoiceApproval.initiate": "發起INV審批",
  "invoiceApproval.review": "審核INV",
  "invoiceApproval.confirm": "確認審核通過INV？",
  "orderForm.nonNegative": "請輸入大於或等於0的數值",
  "orderForm.selectBuyerCompany": "請選擇買方公司",
  "contractReview.draftFailed": "取得合同草稿失敗",
  "orderFollow.businessTracking": "商務跟單",
  "orderFollow.hideConfirm": "確定隱藏此資訊嗎？",
  "orderFollow.hidden": "已隱藏",
  "orderFollow.businessAcceptance": "商務接單",
  "preOrder.edit": "修改購買意向單",
  "preOrder.updatedAwaitingPurchase": "修改確認成功！等待採購談判人確認！",
  "orderFollow.negotiatorAcceptance": "談判人接單",
  "orderFollow.hideLeadConfirm": "確定隱藏此線索嗎？",
  "preOrder.confirmPurchase": "確認購買意向單",
  "preOrder.purchaseTracking": "採購談判人－跟單詳情",
  "preOrder.salesTracking": "銷售談判人－跟單詳情",
  "inspection.outerPackaging": "外包裝",
  "inspection.middlePackaging": "中包裝",
  "inspection.minimumPackaging": "最小包裝",
  "inspection.productDetails": "產品細節",
  "inspection.confirmDelete": "確認刪除",
  "inspection.completeConfirm": "確認後將完成本次驗貨，是否繼續？",
  "inspection.submitConfirm": "確認後將提交本次驗貨結果，是否繼續？",
  "contractRoles.initiator": "發起人",
  "contractRoles.selfReview": "自審",
  "contractRoles.businessManager": "商務經理",
  "contractRoles.businessDirector": "業務總監",
  "contractRoles.generalManager": "總經理",
  "contractRoles.negotiatorManager": "談判人主管",
  "contractReview.reviewAndCc": "審核與副本收件人",
  "contractReview.noReviewers": "暫無審核人",
  "contractReview.loadingCc": "正在載入預設副本收件人",
  "contractReview.reviewLevel": "第{level}級審核",
  "contractReview.removeReviewer": "刪除{role}：{name}",
  "contractReview.keepReviewer": "至少保留一個審核節點",
  "contractReview.deleteReviewer": "刪除審核人",
  "contractReview.removeCc": "移除{name}",
  "purchasePayment.noApprovalFlow": "暫未取得付款審批流程",
  "purchasePayment.reviewerRemarkHint":
    "請填寫審核人備註（填寫本次付款審核處理意見）",
  "orderFollow.confirmMerge": "確認合併",
  "orderFollow.noAvailableOrders": "暫無可接訂單，請稍候",
  "preOrder.enterPrice": "請填寫意向價格",
  "preOrder.quantity": "意向數量",
  "preOrder.buyerCommissionRate": "買家佣金比例",
  "preOrder.sellerCommissionRate": "貨主佣金比例",
  "preOrder.enterCommissionRate": "請填寫佣金比例",
  "preOrder.estimatedPayment": "約需支付",
  "preOrder.usdSuffix": "美元；",
  "preOrder.cnySuffix": "人民幣；",
  "preOrder.tradeNotes": "交易資訊備註",
  "preOrder.enterTradeNotes": "請輸入交易資訊備註",
  "preOrder.sellerContacts": "貨主聯絡資訊",
  "preOrder.buyerContacts": "買家聯絡資訊",
  "preOrder.buyerPrefix": "買主－",
  "preOrder.buyerProviderPrefix": "買家資訊提供人－",
  "preOrder.confirm": "確認意向單",
  "preOrder.purchaseBusinessPrefix": "採購商務－",
  "preOrder.buyerRolePrefix": "買家－",
  "preOrder.clearSelection": "清除選取",
  "orderDetails.sampleTitle": "詳情AAA",
  "orderDetails.sampleNumber": "訂單編號A：",
  "preOrder.myEnquiries": "我的意向單",
  "inspection.myInspections": "我的驗貨",
  "inspection.pending": "待驗貨",
  "inspection.inspect": "前往驗貨",
  "inspection.chooseWarehouse": "請選擇入倉倉庫",
  "inspection.chooseDate": "請選擇入倉日期",
  "inspection.previousYear": "上一年",
  "inspection.nextYear": "下一年",
  "inspection.clearDate": "清空日期",
  "outboundAudit.companyLookupHint": "輸入{field}查詢",
  "tradeContract.installment": "分期",
  "tradeContract.fullPayment": "全款",
  "tradeContract.deleteFailed": "刪除失敗！請重試！",
  "orderFollow.claimSuccess": "搶單成功",
  "orderFollow.contactSellerHint": "您已成功接單，請盡快聯繫貨主確認貨源資訊",
  "orderFollow.contactBuyerHint": "您已成功接單，請盡快聯繫買家確認意向單資訊",
  "orderFollow.awaitSalesHint": "您已成功接單，請等待銷售商務接單",
  "orderFollow.editContractHint": "您已成功接單，請前往編輯交易合同資訊",
  "orderFollow.backToFollow": "返回跟單",
  "externalPayment.amount": "支付金額",
  "externalPayment.remainingTime": "支付剩餘時間",
  "externalPayment.confirm": "確認付款",
  "externalPayment.title": "對外付款",
  "externalPayment.sellerAmount": "貨主支付金額",
  "externalPayment.sellerStatus": "貨主付款狀態",
  "externalPayment.copySellerLink": "複製貨主付款連結",
  "externalPayment.buyerAmount": "買家支付金額",
  "externalPayment.buyerStatus": "買家付款狀態",
  "externalPayment.buyerTime": "買家付款時間",
  "externalPayment.copyBuyerLink": "複製買家付款連結",
  "outboundAudit.autoFillHint": "選擇產品和入倉號後自動填入",
  "outboundAudit.remarkPlaceholder": "請輸入審核備註（選填，最多200字）",
  "outboundAudit.reloadRemarks": "重新載入審核備註",
  "outboundAudit.reloadCc": "重新載入副本收件人",
  "outboundAudit.rejectTitle": "駁回出庫單",
  "outboundAudit.rejectReasonRequired": "請填寫駁回原因（必填）",
  "outboundAudit.resubmit": "重新發起出庫單審批",
  "outboundAudit.initiateReview": "發起出庫單審核",
  "outboundAudit.initiateApproval": "發起出庫單審批",
  "outboundAudit.resubmitConfirm": "確認重新發起此出庫單審批？",
  "outboundAudit.submitConfirm": "確認提交此出庫單審批？",
  "outboundAudit.approveConfirm": "確認審核通過此出庫單？",
  "outboundAudit.reviewConfirmFailed": "審核確認失敗，請重試",
  "outboundAudit.rejectConfirmFailed": "駁回確認失敗，請重試",
  "outboundAudit.relatedOrderFailed": "關聯訂單載入失敗，請返回後重試",
  "outboundAudit.relatedDataFailed": "出庫單關聯資料載入失敗，請返回後重試",
  "outboundAudit.contractDetailFailed": "取得合同詳情失敗",
  "outboundAudit.enterNewNumber": "請輸入新的出庫單號",
  "outboundAudit.newNumberRequired": "重新發起審批請填寫不同於原單的新出庫單號",
  "outboundAudit.enterNumber": "請填寫出庫單號",
  "outboundAudit.remarksLoading": "正在載入審核備註...",
  "outboundAudit.reviewersLoading": "正在載入審批人...",
  "outboundAudit.noReviewers": "暫無審批人",
  "outboundAudit.noCc": "暫無副本收件人",
  "outboundAudit.rejectReasonLimit": "駁回原因不能超過200字",
  "outboundAudit.rejectReasonHint": "請填寫駁回原因（必填，最多200字）",
  "outboundAudit.productLabel": "產品{number}",
  "outboundAudit.collapseParty": "收起{party}資訊",
  "outboundAudit.expandParty": "查看更多{party}資訊",
  "orderFollow.myContracts": "我產生的合同",
  "orderFollow.trading": "交易中",
  "orderFollow.completed": "已完成",
  "orderFollow.awaitContractConfirmation": "待確認交易合同",
  "orderFollow.awaitSalesContract": "待銷售商務產生交易合同",
  "orderFollow.awaitContractCreation": "待產生交易合同",
  "orderFollow.contractCreated": "已產生交易合同",
  "orderFollow.tradePrice": "交易價格",
  "orderFollow.tradeQuantity": "交易數量",
  "orderFollow.intermediateSellerCompany": "中間貨主公司",
  "orderFollow.intermediateBuyerCompany": "中間買家公司",
  "orderFollow.orderCreatedAt": "訂單產生時間",
  "orderFollow.sellerPrefix": "貨主－",
  "orderFollow.purchaseNegotiatorPrefix": "採購談判人－",
  "orderFollow.salesNegotiatorPrefix": "銷售談判人－",
  "orderFollow.salesBusinessPrefix": "銷售商務－",
  "orderFollow.supervisorPrefix": "監督人－",
  "orderFollow.inspectorPrefix": "驗貨人－",
  "orderFollow.businessDetail": "商務跟單詳情",
  "orderFollow.purchaseBusinessDetail": "採購商務－跟單詳情",
  "orderFollow.salesBusinessDetail": "銷售商務－跟單詳情",
  "tradeContract.enterUnitPrice": "請填寫商品單價",
  "tradeContract.enterQuantity": "請填寫商品數量",
  "tradeContract.enterTotal": "請填寫總金額",
  "tradeContract.sellerFee": "貨主交易費",
  "tradeContract.enterSellerFee": "請填寫貨主應付交易費",
  "tradeContract.buyerFee": "買家交易費",
  "tradeContract.enterBuyerFee": "請填寫買家應付交易費",
  "tradeContract.enterDeliveryDate": "請填寫交貨日期",
  "tradeContract.uploadDocuments": "上傳合同資料",
  "tradeContract.enterAfterSalesTerms": "請輸入售後條款",
  "tradeContract.confirmed": "確認合同成功！",
});

export const workflowFeedback = Object.freeze({
  "workflowFeedback.sellerCompany": "賣方公司",
  "workflowFeedback.buyerCompany": "買方公司",
  "workflowFeedback.bankAccountName": "銀行帳戶名",
  "workflowFeedback.noPurchases": "暫無可選擇的採購商品",
  "workflowFeedback.lockedPurchase": "該商品不能取消選擇",
  "workflowFeedback.sameNegotiator": "買賣談判人同一個",
  "workflowFeedback.sameBusiness": "買賣商務同一個",
  "workflowFeedback.reviewPermissionMissing": "暫無權限評價",
  "workflowFeedback.currentStage": "目前階段：",
  "workflowFeedback.flowProgress": "流程 {current} / {total}",
  "workflowFeedback.splitCount": "拆分單數",
  "workflowFeedback.allocateQuantities": "分配拆分數量",
  "workflowFeedback.allocationHint": "每單數量之和需等於商品總數",
  "workflowFeedback.allocationComplete": "已分配完成",
  "workflowFeedback.remainingQuantity": "剩餘 {quantity}",
  "workflowFeedback.selectablePeople": "可選{role}",
  "workflowFeedback.peopleCount": "共 {count} 人",
  "workflowFeedback.personSearchGuide": "輸入{role}姓名搜尋並添加",
  "workflowFeedback.ccSearchPlaceholder": "搜尋抄送人姓名",
  "workflowFeedback.noSelectableCc": "暫無可選抄送人",
  "workflowFeedback.paymentInformation": "付款資訊",
  "workflowFeedback.buyerDetails": "買方資料",
  "workflowFeedback.collapseSeller": "收起賣方資料",
  "workflowFeedback.collapseBuyer": "收起買家資料",
  "workflowFeedback.orderTotal": "訂單總價",
  "workflowFeedback.tradingParties": "交易雙方資訊",
  "workflowFeedback.viewContract": "查看合同",
  "workflowFeedback.quick": "快捷",
  "workflowFeedback.createTradeOrder": "產生交易訂單",
  "workflowFeedback.quickPurchaseOrder": "快速產生採購訂單",
  "workflowFeedback.blockInformation": "封鎖此資訊",
  "workflowFeedback.claimOrder": "搶單",
  "workflowFeedback.quickPurchaseContract": "快速產生採購合同",
  "workflowFeedback.goPay": "去支付",
  "workflowFeedback.contractNumberPrefix": "合同號：",
  "workflowFeedback.goodsNumberPrefix": "商品號：",
  "workflowFeedback.confirmTradeOrder": "確認交易訂單",
  "workflowFeedback.totalCny": "總金額 ¥",
  "workflowFeedback.acceptedAt": "接單時間：",
  "workflowFeedback.supplyClueNegotiator": "貨源線索談判人",
  "workflowFeedback.demandClueNegotiator": "求購線索談判人",
  "workflowFeedback.supplyGoodsNegotiator": "貨源商品談判人",
  "workflowFeedback.purchaseGoodsNegotiator": "購買商品談判人",
  "workflowFeedback.purchaseTradeNegotiator": "交易採購談判人",
  "workflowFeedback.salesTradeNegotiator": "交易銷售談判人",
  "workflowFeedback.informationPrice": "資訊價格",
  "workflowFeedback.originalPricePrefix": "商品原價：",
  "workflowFeedback.buyerProviderPrefix": "買方資訊提供人：",
  "workflowFeedback.selectMultiple": "請選擇（多選）",
  "workflowFeedback.reviewSucceeded": "{type}審核成功",
  "workflowFeedback.reviewRejected": "{type}已駁回",
  "workflowFeedback.conditionLoadFailed": "貨物情況選項載入失敗，可稍後重試",
  "workflowFeedback.purchaseItemsUpdated": "採購商品已更新",
  "workflowFeedback.keepCurrentPurchase": "至少保留目前採購商品",
  "workflowFeedback.negotiatorSearchFailed": "談判人搜尋失敗",
  "workflowFeedback.sellerReviewersLoadFailed":
    "賣方審核人員載入失敗，可稍後重試",
  "workflowFeedback.reviewersLoadFailed": "審核人員載入失敗，可稍後重試",
  "workflowFeedback.ccSearchFailed": "搜尋抄送人失敗",
  "workflowFeedback.ccAdded": "抄送人已添加",
  "workflowFeedback.draftSaved": "草稿已儲存",
  "workflowFeedback.draftSaveFailed": "草稿儲存失敗",
  "workflowFeedback.purchaseQuoteRequired": "請先完成採購報價",
  "workflowFeedback.purchaseUnavailable": "目前商品暫不允許產生採購訂單",
  "workflowFeedback.purchaseCreated": "採購訂單產生成功",
  "workflowFeedback.createOrderFailed": "產生訂單失敗",
  "workflowFeedback.purchaseQuoteSubmitted": "採購報價提交成功",
  "workflowFeedback.purchaseQuoteFailed": "採購報價提交失敗",
  "workflowFeedback.sellerFieldRequired": "賣方{field}不能為空",
  "workflowFeedback.buyerFieldRequired": "買方{field}不能為空",
  "workflowFeedback.newClaimInformation": "新的搶單資訊",
  "workflowFeedback.noClaimInformation": "暫無可搶單資訊",
  "workflowFeedback.rejectFailed": "駁回失敗",
  "workflowFeedback.installmentIncomplete":
    "請先填寫完整{installment}的付款金額和付款時間",
  "workflowFeedback.installmentDateOrder":
    "{current}的付款時間不能早於{previous}的付款時間",
  "workflowFeedback.installmentProofRequired": "請上傳{installment}的支付憑證",
  "workflowFeedback.installmentCompanyRequired":
    "請選擇{installment}的下單公司",
  "workflowFeedback.installmentBankRequired": "請選擇{installment}的付款銀行",
  "workflowFeedback.reviewFailed": "審核失敗",
  "workflowFeedback.inspectionMissing": "驗貨資料不存在",
  "workflowFeedback.warehouseQuantityLimit":
    "入倉明細實際數量之和不能大於{quantity}",
  "workflowFeedback.warehouseDeleteFailed": "刪除入倉明細失敗",
  "workflowFeedback.batchInspectionLoadFailed": "批次驗貨資料載入失敗",
  "workflowFeedback.confirmBatchInspection":
    "確認後將提交 {count} 個商品的驗貨結果，是否繼續？",
  "workflowFeedback.batchInspectionSaveFailed": "驗貨資訊批次儲存失敗",
  "workflowFeedback.batchInspectionConfirmFailed": "批次確認驗貨失敗",
  "workflowFeedback.batchInspectionRetry": "批次確認驗貨失敗，請稍後重試",
  "workflowFeedback.uploadingBeforeSave": "圖片或影片上傳中，請稍後儲存",
  "workflowFeedback.loadingBeforeSave": "資料載入中，請稍後儲存",
  "workflowFeedback.inspectionSaveFailed": "驗貨資訊儲存失敗",
  "workflowFeedback.inspectionSaveRetry": "驗貨資訊儲存失敗，請稍後重試",
  "workflowFeedback.inspectionConfirmRetry": "確認驗貨失敗，請稍後重試",
  "workflowFeedback.rejectRefresh": "駁回失敗，請重新整理後重試",
  "workflowFeedback.selectedGoodsCount": "已選擇 {selected} / {total} 個{item}",
  "workflowFeedback.viewPaymentReview": "查看付款審核",
  "workflowFeedback.viewPurchaseOrder": "查看採購訂單",
  "workflowFeedback.viewPurchaseContract": "查看採購合同",
  "workflowFeedback.purchaseGoodsRequired": "請至少選擇一個採購商品",
  "workflowFeedback.purchaseGoodsFields": "請完善商品{index}的必填資訊",
});

export const sharedFlowUi = Object.freeze({
  "workflowFeedback.finalPayment": "尾款",
  "workflowFeedback.buyerNotReceived": "*【銷售-買家】尚未收貨，請審慎確認！",
  "workflowFeedback.piProof": "PI 發票憑證",
  "workflowFeedback.ciProof": "CI 發票憑證",
  "workflowFeedback.paymentAuthorization": "付款委託書",
  "workflowFeedback.invoiceUploadIntro": "發票上傳說明",
  "workflowFeedback.shippingEvidenceRequired": "發貨憑證與發貨備註至少填寫一項",
  "workflowFeedback.shippingNotePlaceholder":
    "可補充配送要求、預計送達時間等資訊（選填）",
  "workflowFeedback.invoiced": "已開票",
  "workflowFeedback.paymentEnded": "已結束",
  "workflowFeedback.totalReceivable": "應收總額",
  "workflowFeedback.endPaymentHint": "開啟後表示該訂單無需繼續補充付款憑證",
  "workflowFeedback.pendingOrderInformation": "待確認訂單資訊",
  "workflowFeedback.receiptSummary": "收款彙總",
  "workflowFeedback.noPaymentProofHint":
    "暫無付款憑證，請先與買方核實款項到帳情況",
  "workflowFeedback.notInvoiced": "未開票",
  "workflowFeedback.paymentNotEnded": "未結束",
  "workflowFeedback.endPayment": "本次付款是否結束",
  "workflowFeedback.viewOrderNodes": "查看訂單、合同與付款節點",
  "workflowFeedback.checkOrderInformation": "核對商品、付款與開票資訊",
  "workflowFeedback.viewProofHint": "點擊憑證可查看檔案詳情",
  "workflowFeedback.logisticsInformation": "物流資訊",
  "workflowFeedback.logisticsNotes": "物流備註",
  "workflowFeedback.receiptConfirmHint":
    "確認後將記錄本次收款結果，請確保實際款項已到帳。",
  "workflowFeedback.orderInvoiceProof": "訂單開票憑證",
  "workflowFeedback.orderTotalAmount": "訂單總金額",
  "workflowFeedback.requiredFields": "請填寫必填項！",
  "workflowFeedback.addressRequired": "請新增或更換收貨地址",
  "workflowFeedback.paymentProofRequired": "請至少上傳一份支付憑證",
  "workflowFeedback.paymentProofRequiredAlert": "請至少上傳一份支付憑證！",
  "workflowFeedback.logisticsCompanyRequired": "請輸入物流公司名稱",
  "workflowFeedback.invoiceCount": "已添加{count}個發票檔案，可確認上傳",
  "workflowFeedback.invoiceRequired": "請至少添加一份發票後再確認上傳",
  "workflowFeedback.receiptCheckHint": "請在核對商品及隨貨資料無誤後完成確認",
  "workflowFeedback.notConfirmYet": "暫不確認",
  "workflowFeedback.shippingIntro": "填寫本次發貨資訊，便於買家及時追蹤物流",
  "workflowFeedback.checkReceiptHint": "請核對訂單、收款金額與付款憑證",
  "workflowFeedback.payerCompany": "付款公司（買方）",
  "workflowFeedback.payeeCompany": "收款公司（賣方）",
  "workflowChat.agentManager": "群管理：群聊Agent",
  "workflowChat.groupInitial": "群",
  "workflowChat.groupSettings": "群聊設定（{count}人）",
  "workflowChat.privateChat": "私聊",
  "workflowChat.mention": "提醒成員",
  "workflowChat.mentionedMe": "有人@我",
  "workflowChatAgent.readOnly": "唯讀分析",
  "workflowChat.agentName": "群聊Agent",
  "workflowChat.purchaseOrderName": "採購 ",
  "workflowChat.saleOrderName": "銷售 ",
  "workflowChat.purchaseDraftName": "採購草稿 ",
  "workflowChat.saleDraftName": "銷售草稿 ",
  "workflowChat.orderCount": "（{count}單）",
  "workflowChat.dateUnknown": "日期待確認",
  "workflowChat.progress.DRAFT": "待發起",
  "workflowChat.progress.COMPLETED": "交易完成",
  "workflowChat.progress.REJECTED": "審批已駁回",
  "workflowChat.progress.INVALID": "訂單已失效",
  "workflowChat.progress.CLOSED": "交易關閉",
  "workflowChat.progress.WAITING_BUSINESS_CONFIRMATION": "待商務確認",
  "workflowChat.progress.WAITING_PAYMENT": "待付款",
  "workflowChat.progress.WAITING_PAYMENT_PROOF": "待上傳付款憑據",
  "workflowChat.progress.WAITING_PAYMENT_CONFIRMATION": "待確認收款",
  "workflowChat.progress.WAITING_SHIPMENT": "待發貨",
  "workflowChat.progress.WAITING_RECEIPT": "待確認收貨",
  "workflowChat.progress.RECEIPT_CONFIRMED": "已確認收貨",
  "workflowChat.progress.REVIEW_APPROVED": "審核已通過",
  "workflowChat.progress.OUTBOUND_REVIEW": "出庫審批",
  "workflowChat.progress.OUTBOUND_REJECTED": "出庫審批駁回",
  "workflowChat.progress.PROGRESS_UNAVAILABLE": "進度待確認",
  "workflowChat.progress.REVIEW_1": "訂單審核",
  "workflowChat.progress.REVIEW_1_REJECTED": "訂單審核駁回",
  "workflowChat.progress.REVIEW_2": "合同審批",
  "workflowChat.progress.REVIEW_2_REJECTED": "合同審批駁回",
  "workflowChat.progress.REVIEW_3": "付款審批",
  "workflowChat.progress.REVIEW_3_REJECTED": "付款審批駁回",
  "workflowChat.progress.REVIEW_4": "付款方式審批",
  "workflowChat.progress.REVIEW_4_REJECTED": "付款方式審批駁回",
  "workflowChat.progress.REVIEW_5": "INV審批",
  "workflowChat.progress.REVIEW_5_REJECTED": "INV審批駁回",
  "workflowChat.progress.REVIEW_6": "出貨審批",
  "workflowChat.progress.REVIEW_6_REJECTED": "出貨審批駁回",
  "workflowChat.fullChain": "全流程協作",
  "workflowChat.allMembers": "所有人",
  "workflowChat.draftUnavailable": "未找到已儲存的草稿，請先暫存後重試。",
  "workflowChat.scopeUnavailable": "當前頁面的審批鏈尚未準備好，或無法唯一確定付款批次。",
  "workflowChat.entry": "流程協作",
  "workflowChat.title": "流程協作群",
  "workflowChat.currentScope": "目前單據流程",
  "workflowChat.selectScope": "選擇流程",
  "workflowChat.active": "討論中",
  "workflowChat.archived": "已封存",
  "workflowChat.cooling": "結束後討論期",
  "workflowChat.readonly": "唯讀封存",
  "workflowChat.round": "第{number}輪",
  "workflowChat.unread": "{count}則未讀",
  "workflowChat.noArchived": "暫無封存討論",
  "workflowChat.noActive": "暫無活躍討論",
  "workflowChat.loadMoreGroups": "載入更多群組",
  "workflowChat.archiveAt": "{time}轉為唯讀封存",
  "workflowChat.memberCount": "討論成員（{count}）",
  "workflowChat.history": "流程聊天記錄",
  "workflowChat.viewingReference": "引用訊息 #{number}",
  "workflowChat.laterMessages": "後續訊息",
  "workflowChat.returnToChat": "返回聊天",
  "workflowChat.referenceUnavailable": "此引用訊息暫不可查看",
  "workflowChat.earlierMessages": "查看較早記錄",
  "workflowChat.noMessages": "暫無討論訊息",
  "workflowChat.newMessages": "查看新訊息",
  "workflowChat.messagePlaceholder":
    "說明情況，與目前流程成員討論。Enter發送，Shift+Enter換行",
  "workflowChat.archivedHint": "此輪討論已封存，可查看歷史記錄。",
  "workflowChat.participantsHint": "將自動納入以下流程成員：",
  "workflowChat.retentionHint":
    "流程結束後保留7天討論，之後唯讀封存，聊天記錄保留。",
  "workflowChat.openingPlaceholder": "填寫發起討論的原因及需要協商的事項",
  "workflowChat.start": "發起流程討論",
  "workflowChat.ccPermissionHint":
    "抄送人可參與已有討論；僅發起人和審核人可建立群組。",
  "workflowChat.emptyHint": "從左側選擇討論，或從單據審批頁面發起流程討論。",
  "workflowChat.roleSeparator": "、",
  "workflowChat.orderApproval": "訂單審批",
  "workflowChat.contractApproval": "合同審批",
  "workflowChat.paymentApproval": "付款審批",
  "workflowChat.paymentMethodApproval": "付款方式審批",
  "workflowChat.invoiceApproval": "發票審批",
  "workflowChat.outboundApproval": "出庫審批",
  "workflowChat.discussion": "流程討論",
  "workflowChat.scopeInstallment": "{scope} · 第{number}期",
  "workflowFeedback.installmentNumber": "第{number}期",
});

// 移动端订单、合同及验货流程的增量显示文案。
export const mobileWorkflowFollowup = Object.freeze({
  "mobileOrderWorkflow.awaitSellerDualStamp": "待貨主上傳雙章合同",
  "mobileOrderWorkflow.awaitBuyerDualStamp": "待買家上傳雙章合同",
  "mobileOrderWorkflow.awaitBusinessDualStamp": "待商務上傳雙章合同",
  "mobileOrderWorkflow.awaitSellerStamp": "待貨主上傳蓋章合同",
  "mobileOrderWorkflow.awaitBuyerStamp": "待買家上傳蓋章合同",
  "mobileOrderWorkflow.paymentReviewUnderReview": "付款流程審核中",
  "mobileOrderWorkflow.paymentReviewRejected": "付款流程已駁回",
  "mobileOrderWorkflow.paymentMethodUnderReview": "付款方式審核中",
  "mobileOrderWorkflow.paymentMethodRejected": "付款方式已駁回",
  "mobileOrderWorkflow.invoiceUnderReview": "INV審核中",
  "mobileOrderWorkflow.invoiceRejected": "INV審核已駁回",
  "mobileOrderWorkflow.confirmInvoiceApproval": "確認INV審批",
  "mobileOrderWorkflow.viewInvoiceApproval": "查看INV審批",
  "mobileOrderWorkflow.itemCountOne": "{count} 項",
  "mobileOrderWorkflow.itemCountMany": "{count} 項",
  "mobileOrderWorkflow.supportedFileTypes": "支援上傳多種類型檔案",
  "mobileOrderWorkflow.invoiceFile": "INV（正式發票）",
  "mobileOrderWorkflow.paymentReviewOpinion": "填寫本次付款審核處理意見",
  "mobileOrderWorkflow.noMergeableOrders": "暫無可合併訂單",
  "mobileOrderWorkflow.noOtherMergeableOrders": "目前沒有其他可合併訂單",
  "mobileOrderWorkflow.packagingImages": "包裝圖片",
  "mobileOrderWorkflow.packagingVideos": "包裝影片",
  "mobileOrderWorkflow.detailImages": "細節圖片",
  "mobileOrderWorkflow.detailVideos": "細節影片",
  "mobileOrderWorkflow.addShortVideo": "新增短片",
  "mobileOrderWorkflow.financeRole": "財務",
  "mobileOrderWorkflow.salesContractNotSubmitted": "銷售合同未提交",
  "mobileOrderWorkflow.buyerContractNotSubmitted": "買家合同未提交",
  "mobileOrderWorkflow.sellerContractNotSubmitted": "貨主未提交合同",
  "mobileOrderWorkflow.invoiceContractNotReviewed": "待發起INV審核【未覆核合同】",
  "mobileOrderWorkflow.orderAcceptedBy": "{name}接單",
  "mobileOrderWorkflow.awaitRoleReview": "待{role}審核",
  "mobileOrderWorkflow.purchaseOrderCreated": "採購訂單已生成",
  "mobileOrderWorkflow.purchaseOrderNotCreated": "採購訂單未生成",
  "mobileOrderWorkflow.salesOrderCreated": "銷售訂單已生成",
  "mobileOrderWorkflow.salesOrderNotCreated": "銷售訂單未生成",
  "mobileOrderWorkflow.purchaseContractSubmitted": "採購合同已提交",
  "mobileOrderWorkflow.purchaseContractNotSubmitted": "採購合同未提交",
  "mobileOrderWorkflow.purchaseTemplateSubmitted": "採購合同範本已提交",
  "mobileOrderWorkflow.salesContractSubmitted": "銷售合同已提交",
  "mobileOrderWorkflow.salesContractNotCreated": "銷售合同未生成",
  "mobileOrderWorkflow.awaitSellerReview": "待貨主審核",
  "mobileOrderWorkflow.awaitBuyerReview": "待買家審核",
  "mobileOrderWorkflow.buyerReviewed": "買家已審核",
  "mobileOrderWorkflow.awaitBusinessStamp": "待商務上傳蓋章合同",
  "mobileOrderWorkflow.awaitSellerProductLink": "待貨主綁定商品",
  "mobileOrderWorkflow.sellerProductLinked": "貨主已綁定商品",
  "mobileOrderWorkflow.purchaseQuoted": "已採購報價",
  "mobileOrderWorkflow.awaitBusinessInspection": "待商務驗貨",
  "mobileOrderWorkflow.awaitManagerInspection": "待商務經理驗貨",
  "mobileOrderWorkflow.inspectionCompleted": "驗貨完成",
  "mobileOrderWorkflow.awaitDualStamp": "待上傳雙章合同",
  "mobileOrderWorkflow.dualStampUploaded": "已上傳雙章合同",
  "mobileOrderWorkflow.awaitPaymentProof": "待上傳付款憑證",
  "mobileOrderWorkflow.awaitPaymentProofConfirmation": "待確認付款憑證",
  "mobileOrderWorkflow.paymentProofConfirmed": "已確認付款憑證",
  "mobileOrderWorkflow.paymentReviewFlow": "付款審核流程",
  "mobileOrderWorkflow.reviewPaymentWorkflow": "付款流程審核",
  "mobileOrderWorkflow.sellerReceiptConfirmed": "賣家已確認收款",
  "mobileOrderWorkflow.awaitBuyerPayment": "待買家付款",
  "mobileOrderWorkflow.buyerPaid": "買家已付款",
  "mobileOrderWorkflow.financeReceiptConfirmed": "財務確認收款",
  "mobileOrderWorkflow.customerReceived": "客戶已收貨",
  "mobileOrderWorkflow.sellerShipped": "賣家已發貨",
  "mobileOrderWorkflow.sellerNotShipped": "賣家未發貨",
  "mobileOrderWorkflow.notShipped": "未發貨",
  "mobileOrderWorkflow.reviewCompleted": "審核完成",
  "mobileOrderWorkflow.reviewRecordMissing": "審核記錄未生成",
  "mobileOrderWorkflow.paymentReviewCompleted": "付款流程審核完成",
  "mobileOrderWorkflow.paymentReviewRecordMissing": "付款流程審核記錄未生成",
  "mobileOrderWorkflow.paymentReviewNotStarted": "付款流程待發起",
  "mobileOrderWorkflow.paymentMethodReviewed": "付款方式審核完成",
  "mobileOrderWorkflow.paymentMethodNotStarted": "付款方式待發起",
  "mobileOrderWorkflow.invoiceReviewNotStarted": "待發起INV審核",
  "mobileOrderWorkflow.invoiceNotStarted": "待發起INV",
  "mobileOrderWorkflow.invoiceReviewed": "INV審核完成",
  "mobileOrderWorkflow.accountant": "會計",
  "mobileOrderWorkflow.cashier": "出納",
  "mobileOrderWorkflow.reviewPurchaseOrder": "審核採購訂單",
  "mobileOrderWorkflow.confirmPurchaseOrder": "確認採購訂單",
  "mobileOrderWorkflow.confirmContract": "確認合同",
  "mobileOrderWorkflow.confirmInvoice": "確認INV",
  "mobileOrderWorkflow.confirmPaymentApproval": "確認付款審批",
  "mobileOrderWorkflow.viewPaymentApproval": "查看付款審批",
  "mobileOrderWorkflow.startPaymentMethodApproval": "發起付款方式審批",
  "mobileOrderWorkflow.ownerNotReviewed": "貨主未審核",
  "mobileOrderWorkflow.ownerReviewed": "貨主已審核",
  "mobileOrderWorkflow.paymentNotSubmitted": "付款流程未提交",
  "mobileOrderWorkflow.paymentUnderReview": "付款審核中",
  "mobileOrderWorkflow.paymentComplete": "付款完成",
  "mobileOrderWorkflow.pendingPayment": "待付款",
  "mobileOrderWorkflow.paid": "已付款",
  "mobileOrderWorkflow.paying": "付款中",
  "mobileOrderWorkflow.paymentFailed": "付款失敗",
  "mobileOrderWorkflow.purchasePaymentContract": "採購付款合同",
  "mobileOrderWorkflow.standardContract": "一般合同",
  "mobileOrderWorkflow.approvalEnded": "審批已結束",
  "mobileOrderWorkflow.orderCompleted": "訂單完成",
  "mobileOrderWorkflow.fillRemarks": "填寫備註",
  "mobileOrderWorkflow.paymentUnavailable": "暫時無法取得付款資料",
  "mobileOrderWorkflow.networkRetry": "網絡異常，請稍後重試",
  "mobileOrderWorkflow.initiateWithoutPi": "供應商尚未上傳PI，確認發起付款審批？",
  "mobileOrderWorkflow.initiatePaymentConfirmation": "確認發起付款審核？",
  "mobileOrderWorkflow.approveOrderConfirmation": "確認訂單審核通過？",
  "mobileOrderWorkflow.approveContractConfirmation": "確認合同審核通過？",
  "mobileOrderWorkflow.contractRelatedHint": "選擇需要關聯至本次合同審批的歷史訂單、合同或付款審核記錄",
  "mobileOrderWorkflow.inspectionOrderLoading": "訂單編號載入中",
  "mobileOrderWorkflow.inspectionGoodsRequired": "缺少商品編號，請返回訂單頁重新進入",
  "mobileOrderWorkflow.inspectionLoadFailed": "載入商品失敗",
  "mobileOrderWorkflow.inspectionStatusLoadFailed": "載入驗貨狀態失敗",
  "mobileOrderWorkflow.inspectionRetry": "載入失敗，請稍後重試",
  "mobileOrderWorkflow.inspectionReadFailed": "驗貨資料讀取失敗",
  "mobileOrderWorkflow.inspectionSelectionMissing": "找不到已選商品",
  "mobileOrderWorkflow.inspectionAttachment": "驗貨附件",
  "mobileOrderWorkflow.inspectionProductLabel": "商品{number}",
  "mobileOrderWorkflow.warehouseUnified": "已統一至其他 {count} 個商品",
  "mobileOrderWorkflow.inspectionBatchConfirmed": "已批量確認 {count} 個商品",
  "mobileOrderWorkflow.productDataLoadFailed": "{name}資料載入失敗",
  "mobileOrderWorkflow.productInspectionNotAllowed": "{name}目前狀態不允許確認驗貨",
  "mobileOrderWorkflow.productApprovalRemarkRequired": "{name}的審批備註不能為空",
  "mobileOrderWorkflow.productWarehouseQuantityRequired": "{name}的每項入倉實際數量必須大於0",
  "mobileOrderWorkflow.goodsRequiredInfo": "商品必填資料",
  "mobileOrderWorkflow.productRequiredInfo": "產品必填資料",
  "mobileOrderWorkflow.partiesRequiredInfo": "交易雙方必填資料",
  "mobileOrderWorkflow.reviewerInfo": "審核人資料",
  "mobileOrderWorkflow.noProductProviders": "暫無可選商品提供人",
  "mobileOrderWorkflow.buyerContactPhone": "買方聯絡電話",
  "mobileOrderWorkflow.orderLoadFailed": "訂單資料載入失敗",
  "mobileOrderWorkflow.purchaseAccessDenied": "目前帳號無權查看生成採購訂單，請切換至採購商務帳號。",
  "mobileOrderWorkflow.orderLoadRetry": "訂單資料載入失敗，請返回首頁後重試。",
  "mobileOrderWorkflow.goodsLoadFailed": "取得商品資料失敗",
  "mobileOrderWorkflow.draftSaved": "儲存草稿成功",
  "mobileOrderWorkflow.salesMergedContract": "銷售商務快捷合併交易合同",
  "mobileOrderWorkflow.sellerProvider": "貨主資料提供人",
  "mobileOrderWorkflow.buyerProvider": "買家資料提供人",
  "mobileOrderWorkflow.deliveryNote": "送貨單",
  "mobileOrderWorkflow.inspectGoodsLoadFailed": "取得驗貨商品清單失敗"
});

export const messages = Object.freeze({
  ...mobileWorkflowFollowup,
  ...sharedFlowUi,
  ...workflowFeedback,
  ...mobileWorkflow,
  "purchasePayment.supplierPiMissingApprovalConfirm":
    "供應商尚未上載PI，確定通過審批？",
  "purchasePayment.approvalConfirm": "確認通過付款審批？",
  ...contractFlow,
  ...outboundList,
  ...buy,
  ...contact,
  ...broker,
  ...checkout,
  ...mobileComponents,
  ...mobile,
  ...mobileCart,
  ...mobileTransactions,
  ...details,
  ...desktopCart,
  ...contractReview,
  ...follow,
  ...desktopComponents,
  ...desktopTransactions,
  ...personal,
  ...split,
  "outboundAudit.priceUnit": "價格單位",
  "outboundAudit.goodsQuantity": "訂單數量",
  "outboundAudit.warehouseQuantity": "入倉數量",
  "outboundAudit.stockQuantity": "庫存數量",
});
